import angular from 'angular';

import customer from './customer';
import directive from './customers.directive';
import controller from './customers.controller';

export default angular.module('admin.userAdmin.editUserCustomerAssignmentsDialog.customers', [
  customer
])
  .directive('uaCustomers', directive)
  .controller('UACustomersController', controller)
  .name;

console.log('admin.userAdmin.editUserCustomerAssignmentsDialog.customers created');
